<template>
    <div class="wrap grey-bg">
        <div class="box1200">
            <div class="index-title">
                <h3 class="title">企业推广</h3>
                <p class="sort-title">解决企业营销难 全新推广方式</p>
            </div>
            <!--index-title-->
            <el-carousel indicator-position="outside" trigger="click" arrow="always" height="400px" class="Bbox">
                <el-carousel-item v-for="item in bList" :key="item.id">
                    <div class="Bmain">
                        <p class="pic"><img :src="item.imgUrl"></p>
                        <p class="text">{{item.text}}</p>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <!--企业推广轮播-->
            <router-link to="/enterprise-register/attestation" class="index-btn" v-if="this.$store.state.user_type === 3">立即入驻</router-link>
            <router-link to="/enterprise/release" class="index-btn" v-if="this.$store.state.user_type === 0 && this.$store.state.is_auth === 1 && this.$store.state.rank === 1">立即发布推广</router-link>
        </div>
    </div>
</template>
<script>
export default {
  name: 'HomeEnterprise',
  data () {
    return {
      bList: [
        { id: '0', imgUrl: ('https://img.xiaochengdaren.com/2019101013520.png'), text: '企业下单操作简便，无时间档期限制，随时随地轻松做推广' },
        { id: '1', imgUrl: ('https://img.xiaochengdaren.com/2019101063614.png'), text: '300元起投，花小钱做大推广' },
        { id: '2', imgUrl: ('https://img.xiaochengdaren.com/2019101099833.png'), text: '500+同城优质流量的达人随时待命，全时段的即时推广响应服务' },
        { id: '3', imgUrl: ('https://img.xiaochengdaren.com/2019101048742.png'), text: '同城熟人传播、社群传播，快速、直接、精准覆盖目标人群' },
        { id: '4', imgUrl: ('https://img.xiaochengdaren.com/2019101093155.png'), text: '推广全程监测可视，按实际推广效果结算费用' }
      ]
    }
  }
}
</script>
<style>
    .Bmain{text-align: center;}
    .Bmain .text{font-size:20px;margin-top:30px;}
</style>
